import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function MomSysMoveLotButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.moveLot")}</ActionButtonLayout>;

}

export default MomSysMoveLotButtonLayout;

